var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 8C13.4696 8 12.9609 8.21071 12.5858 8.58579C12.2107 8.96086 12 9.46957 12 10V40H36V10C36 9.46957 35.7893 8.96086 35.4142 8.58579C35.0391 8.21071 34.5304 8 34 8H14ZM40 40V10C40 8.4087 39.3679 6.88258 38.2426 5.75736C37.1174 4.63214 35.5913 4 34 4H14C12.4087 4 10.8826 4.63214 9.75736 5.75736C8.63214 6.88258 8 8.4087 8 10V40H6C4.89543 40 4 40.8954 4 42C4 43.1046 4.89543 44 6 44H42C43.1046 44 44 43.1046 44 42C44 40.8954 43.1046 40 42 40H40ZM16 16C16 14.8954 16.8954 14 18 14H20C21.1046 14 22 14.8954 22 16C22 17.1046 21.1046 18 20 18H18C16.8954 18 16 17.1046 16 16ZM26 16C26 14.8954 26.8954 14 28 14H30C31.1046 14 32 14.8954 32 16C32 17.1046 31.1046 18 30 18H28C26.8954 18 26 17.1046 26 16ZM16 24C16 22.8954 16.8954 22 18 22H20C21.1046 22 22 22.8954 22 24C22 25.1046 21.1046 26 20 26H18C16.8954 26 16 25.1046 16 24ZM26 24C26 22.8954 26.8954 22 28 22H30C31.1046 22 32 22.8954 32 24C32 25.1046 31.1046 26 30 26H28C26.8954 26 26 25.1046 26 24ZM16 32C16 30.8954 16.8954 30 18 30H20C21.1046 30 22 30.8954 22 32C22 33.1046 21.1046 34 20 34H18C16.8954 34 16 33.1046 16 32ZM26 32C26 30.8954 26.8954 30 28 30H30C31.1046 30 32 30.8954 32 32C32 33.1046 31.1046 34 30 34H28C26.8954 34 26 33.1046 26 32Z",
    fill: "#1E293B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/building.b19ca9b5309fb5ca1326a8c5080b1f77.svg";
export { ForwardRef as ReactComponent };